import React, { useEffect } from "react";
import {
  ArrayInput,
  maxLength,
  maxValue,
  minLength,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  useGetList,
} from "react-admin";
import { Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { settings } from "app";
import { ScholarshipCategoryChoices, SchorashipTypeChoices } from "utils/choices";
import { RichTextInput } from "ra-input-rich-text";
import { studentRequests } from "api/studentApi";

const SaveForm = () => {
  const { setValue } = useFormContext();
  const { data, isLoading } = useGetList(studentRequests.getAcademicYearsSelect(), {});

  useEffect(() => {
    if (!isLoading && data?.length) {
      setValue("academicYearId", data[0].id);
    }
  }, [isLoading, data, setValue]);
  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="nameBg"
            label="Име на български"
            validate={[required(), maxLength(250), minLength(1)]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="nameEn"
            label="Име на английски"
            validate={[required(), maxLength(250), minLength(1)]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <SelectInput
            source="academicYearId"
            label="Учебна  година"
            choices={data ?? []}
            isLoading={isLoading}
            emptyText={false}
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="sessionType"
            reference={studentRequests.getAcademicSessionTypesSelect()}
            filter={{ SemestersOnly: true }}
          >
            <SelectInput
              label="Семестър"
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
      </Grid>

      <Typography
        color="primary"
        mt={2}
      >
        Кандидатстване за стипендии
      </Typography>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={2}
        >
          <CustomDateInput
            label="Начална дата"
            source="applicationStartDate"
            required
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
        >
          <CustomDateInput
            label="Крайна дата"
            source="applicationEndDate"
            required
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
        >
          <NumberInput
            label="Брой семестри за среден успех"
            source="semestersForGradeCalculation"
            validate={[required(), maxValue(12), minValue(1)]}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <RichTextInput
            source="termsAndConditions"
            label="Правила и условия"
            variant="outlined"
            fullWidth
          />
        </Grid>
      </Grid>

      <Typography
        color="primary"
        mt={2}
      >
        Средно месечен доход на член от семейството
      </Typography>

      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={2}
        >
          <NumberInput
            label="Средно-месечен доход"
            source="maxIncomePerFamilyMember"
            step="0.01"
            validate={required()}
            parse={value => {
              const str = value.toString();
              if (str.includes(".")) {
                const [int, dec] = str.split(".");
                return parseFloat(`${int}.${dec.slice(0, 2)}`);
              }
              return parseFloat(value);
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
        >
          <CustomDateInput
            label="Начална дата"
            source="familyIncomeStartDate"
            noTime
            required
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
        >
          <CustomDateInput
            label="Крайна дата"
            source="familyIncomeEndDate"
            noTime
            required
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <Typography
            color="primary"
            mt={2}
          >
            Скала за доходи
          </Typography>
          <ArrayInput
            source="incomeScales"
            label=""
            defaultValue={[{}, {}, {}, {}]}
          >
            <SimpleFormIterator
              disableReordering
              disableClear
              inline
              sx={settings.style.iteratorWithoutGap}
            >
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <NumberInput
                    source="lowerLimit"
                    label="Долна граница"
                    validate={required()}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <NumberInput
                    source="points"
                    label="Точки"
                    validate={required()}
                  />
                </Grid>
              </Grid>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Typography
            color="primary"
            mt={2}
          >
            Скала за оценки
          </Typography>
          <ArrayInput
            source="gradeScales"
            label=""
            defaultValue={[{}, {}, {}]}
          >
            <SimpleFormIterator
              disableReordering
              disableClear
              inline
              sx={settings.style.iteratorWithoutGap}
            >
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <NumberInput
                    source="lowerLimit"
                    label="Долна граница"
                    step="0.01"
                    validate={required()}
                    parse={value => {
                      const str = value.toString();
                      if (str.includes(".")) {
                        const [int, dec] = str.split(".");
                        return parseFloat(`${int}.${dec.slice(0, 2)}`);
                      }
                      return parseFloat(value);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <NumberInput
                    source="points"
                    label="Точки"
                    validate={required()}
                    parse={value => {
                      const str = value.toString();
                      if (str.includes(".")) {
                        const [int, dec] = str.split(".");
                        return parseFloat(`${int}.${dec.slice(0, 2)}`);
                      }
                      return parseFloat(value);
                    }}
                  />
                </Grid>
              </Grid>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={12}
        >
          <Typography
            color="primary"
            mt={2}
          >
            Стипендии
          </Typography>
          <ArrayInput
            source="scholarships"
            label=""
            defaultValue={[{}]}
          >
            <SimpleFormIterator
              disableReordering
              disableClear
              inline
              sx={settings.style.iteratorWithoutGap}
            >
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  {/* <ReferenceInput
                    source="type"
                    label="Тип стипендия"
                    reference=""
                  > */}
                  <SelectInput
                    source="type"
                    optionText="name"
                    label="Тип стипендия"
                    choices={SchorashipTypeChoices}
                    emptyText={false}
                  />
                  {/* </ReferenceInput> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  {/* <ReferenceInput
                    source="category"
                    label="Категория стипендия"
                    reference=""
                  > */}
                  <SelectInput
                    source="category"
                    optionText="name"
                    label="Категория стипендия"
                    choices={ScholarshipCategoryChoices}
                    emptyText={false}
                  />
                  {/* </ReferenceInput> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <NumberInput
                    source="amount"
                    label="Сума"
                    step="0.01"
                    parse={value => {
                      const str = value.toString();
                      if (str.includes(".")) {
                        const [int, dec] = str.split(".");
                        return parseFloat(`${int}.${dec.slice(0, 2)}`);
                      }
                      return parseFloat(value);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <TextInput
                    source="description"
                    label="Описание"
                  />
                </Grid>
              </Grid>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
    </>
  );
};

export default SaveForm;
